import { generateRelativeDateFromUTCTimestamp } from '../../../app-kit/helpers/generateRelativeDateFromUTCTimestamp';
import { isNotNullOrUndefinedValue } from '../../../helpers/isNotNullOrUndefinedValue';
import { CarouselPropertyCollectionBrick } from './subcomponents/CarouselPropertyCollectionBrick';
import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { mapBadgeVariant } from '../../../app-kit/helpers/mapBadgeVariant';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';

export const CarouselPropertyCollectionBricksWithData: FunctionComponent = () => {
  const propertyCollectionsV3 =
    usePropertyPageQuery()?.data.propertyPageBySlugV3.propertyCollectionsV3;

  if (!propertyCollectionsV3) return null;

  const propertyCollections = (propertyCollectionsV3 ?? []).filter(isNotNullOrUndefinedValue);

  return (
    <>
      {propertyCollections.map(({ title, subtitle, properties, tracking, searchPageWebLink }) => {
        return (
          <CarouselPropertyCollectionBrick
            key={title}
            title={title}
            subtitle={subtitle}
            properties={properties.map(
              ({
                pathV2,
                clickThroughTracking,
                priceV2,
                address,
                image,
                imageV3,
                badgeV2,
                features,
                soldDate,
              }) => ({
                path: pathV2,
                clickThroughSource: clickThroughTracking,
                title: priceV2,
                titleExtra: soldDate ? generateRelativeDateFromUTCTimestamp(soldDate) : null,
                subtitle: address,
                image: imageV3 ?? image,
                badge: {
                  ...badgeV2,
                  variant: mapBadgeVariant(badgeV2.variant),
                },
                features: features?.map((feature) => ({
                  ...feature,
                  iconName: feature.iconNameV2,
                })),
              }),
            )}
            tracking={tracking}
            searchPageWebLink={
              searchPageWebLink
                ? {
                    title: searchPageWebLink.title,
                    url: searchPageWebLink.url,
                    isExternal: searchPageWebLink.isExternal,
                    variant: mapApiWeblinkVariantToLinkVariant(searchPageWebLink?.variant),
                  }
                : null
            }
          />
        );
      })}
    </>
  );
};
